import { useForm } from "react-hook-form";
import { validateMaxlength } from "../../../../utils/validate";

const CourseSearchForm = ({ displayType, setSearchCondition }) => {
  // 受付中
  const Accepting = 1;

  // 検索フォーム用
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // 検索ボタン
  const onSubmit = async (data) => {
    setSearchCondition(data);
  };

  // 条件クリア
  const resetCondition = () => {
    setValue("keyword", "");
    setValue("organ", "");
  };

  return (
    <div className="p-page-search">
      <h2 className="p-page-search__ttl01">
        {displayType === Accepting ? "受付中" : "受付前"}のイベントを検索
      </h2>
      <form className="p-page-form" onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor="keyword">講座名で検索</label>
        <input
          type="text"
          name="keyword"
          id="keyword"
          maxLength="100"
          placeholder="講座名を入力してください"
          {...register("keyword", {
            ...validateMaxlength(100),
          })}
        />
        <label htmlFor="name">実施機関名で検索</label>
        <input
          type="text"
          name="organ"
          id="organ"
          maxLength="100"
          placeholder="実施機関名を入力してください"
          {...register("organ", {
            ...validateMaxlength(100),
          })}
        />
        <input className="p-page-form__btn" type="submit" value="検索する" />
        <input
          className="p-page-form__reset"
          type="reset"
          name="reset"
          value="条件をクリア"
          onClick={() => resetCondition()}
        />
      </form>
    </div>
  );
};

export default CourseSearchForm;
